<template>
    <div class="form-group">
        <div
            class="custom-radio-item"
            v-for="(method, index) in paymentMethods"
            :key="index"
            @click="selectedMethod = method.value"
            :class="{ selected: selectedMethod === method.value }"
        >
            <label class="radio-content">
                <input
                    type="radio"
                    name="paymentMethod"
                    class="custom-control-input"
                    v-model="selectedMethod"
                    :value="method.value"
                />

                <div class="radio-icon">
                    <i :class="method.icon"></i>
                </div>

                <div class="radio-text">
                    <span class="label-text">{{ method.label }}</span>
                </div>

                <span
                    v-if="method.value === 'pay-over-time'"
                    id="sunbit-ala"
                    class="price-text"
                ></span>
            </label>
            <i
                v-if="method.value === 'pay-over-time' && isSunbitLoaded"
                @click.prevent
                v-b-popover.hover.bottom="sunbitDisclaimerContent"
                class="cus-information disclaimer-text"
                container="app"
                title="Note"
            ></i>
        </div>

        <div v-show="false" id="sunbit-ala-disclaimer"></div>
    </div>
</template>
<script>
export default {
    props: {
        data: Object
    },
    data() {
        return {
            selectedMethod: "card",
            paymentMethods: [
                {
                    value: "card",
                    label: "Debit or Credit Card",
                    icon: "fas fa-credit-card"
                },
                {
                    value: "pay-over-time",
                    label: "Pay Over Time",
                    icon: "fas fa-money-check"
                }
            ],
            sunbitAla: null,
            isSunbitLoaded: false,
            observer: null,
            sunbitDisclaimerContent: ""
        };
    },
    watch: {
        selectedMethod(newValue) {
            this.data.defaultPaymentMethod = newValue;
            if (newValue === "pay-over-time" && this.sunbitAla) {
                this.data.isFixedAmount = true;
            }
        }
    },
    mounted() {
        this.loadSunbitSDK();
        this.observeDisclaimer();
    },
    beforeDestroy() {
        if (this.observer) {
            this.observer.disconnect();
        }
    },
    methods: {
        loadSunbitSDK() {
            if (!window.SUNBIT) {
                const script = document.createElement("script");
                script.src = "https://static.sunbit.com/sdk/sunbit-sdk.js";
                script.async = true;
                script.defer = true;
                script.onload = () => this.initSunbit();
                document.head.appendChild(script);
            } else {
                this.initSunbit();
            }
        },
        initSunbit() {
            this.isSunbitLoaded = false;
            this.data.defaultPaymentMethod = "card";
            window.sunbitAsyncInit = () => {
                window.SUNBIT.init({
                    sunbitKey:
                        process.env.VUE_APP_ENV === "PROD"
                            ? process.env.SUNBIT_KEY_PROD
                            : process.env.SUNBIT_KEY_SANDBOX,
                    mode: process.env.VUE_APP_ENV === "PROD" ? "prod" : ""
                });

                this.sunbitAla = window.SUNBIT.UI.asLowAs(
                    "sunbit-ala",
                    "sunbit-ala-disclaimer",
                    {
                        totalAmount: this.data.payment_amount || 0
                    }
                );
            };

            if (window.SUNBIT) {
                window.sunbitAsyncInit();
            }
        },
        observeDisclaimer() {
            this.observer = new MutationObserver(() => {
                const el = document.querySelector(
                    "[id^='sunbit-disclaimer-wrapper']"
                );
                if (el && el.textContent.trim() !== "") {
                    this.sunbitDisclaimerContent = el.textContent.trim();
                    this.updateSunbitFontSize();
                    this.observer.disconnect();
                }
            });

            this.observer.observe(document.body, {
                childList: true,
                subtree: true
            });
        },
        updateSunbitFontSize() {
            setTimeout(() => {
                this.isSunbitLoaded = true;

                const sunbitWrapper = document.querySelector(
                    ".sunbit-ala-wrapper"
                );
                const sunbitLogo = document.querySelector(
                    "[id^='sunbit-ala-logo']"
                );
                const sunbitDisclaimer = document.querySelector(
                    "[id^='sunbit-disclaimer-wrapper']"
                );

                if (sunbitLogo) {
                    sunbitLogo.style.width = "67.1778px";
                    sunbitLogo.classList.remove("sunbit-disclaimer-footnote");
                }
                if (sunbitWrapper) {
                    sunbitWrapper.style.fontSize = "12px";
                }
                if (sunbitDisclaimer) {
                    this.sunbitDisclaimerContent = sunbitDisclaimer.textContent.trim();
                    const visibility = window.getComputedStyle(sunbitDisclaimer)
                        .visibility;

                    if (visibility === "hidden") {
                        this.isSunbitLoaded = false;
                    }
                }
            }, 1000);
            this.$emit("loaded");
        },
        updateAlaPrice(newTotal) {
            if (this.sunbitAla) {
                this.sunbitAla.updateAmount(newTotal);
            }
        }
    }
};
</script>

<style scoped>
.disclaimer-text {
    position: absolute;
    bottom: 10px;
    right: -3px;
}

.custom-radio-item {
    border: 2px solid #ddd;
    border-radius: 8px;
    padding: 15px;
    margin-bottom: 10px;
    transition: 0.3s;
    width: 100%;
    min-height: 60px;
    cursor: pointer;
    display: flex;
    align-items: center;
    position: relative;
    background-color: white;
}

.custom-radio-item.selected {
    border-color: #007bff;
    background-color: #f0f8ff;
}

.radio-content {
    display: flex;
    align-items: center;
    width: 100%;
    cursor: pointer;
}

.radio-icon {
    font-size: 24px; /* Adjust icon size */
    margin-right: 10px;
}

.radio-text {
    display: flex;
    flex-direction: column;
    cursor: pointer;
}

.label-text {
    font-weight: bold;
    cursor: pointer;
}

/* Position price at the bottom right */
.price-text {
    position: absolute;
    bottom: 5px;
    right: 15px;
    font-size: 0.85rem;
    color: gray;
}

/* Adjust Sunbit font size */
::v-deep(.sunbit-ala-wrapper) {
    font-size: 12px !important;
}

/* Hide default radio button */
input[type="radio"] {
    display: none;
}
</style>
